const ngModule = angular.module('bb.user', []);

ngModule.factory('User', ['$window', function($window: any) {
   return $window.User || {};
}]);

export default ngModule;
